import { base_colorAction, progressBarBg } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  width: 100%;
  background-color: ${progressBarBg};
  height: 10px;
  border-radius: 5px;
  position: relative;

  .ProgressBar-inner {
    position: absolute;
    background-color: ${base_colorAction};
    top: 0;
    width: 100px;
    height: 10px;
    border-radius: 5px;
  }

  @keyframes slide-indeterminate {
    from {
      left: 0;
    }
    to {
      left: calc(100% - 100px);
    }
  }
  // VARIANTS
  &.indeterminate {
    .ProgressBar-inner {
      animation: slide-indeterminate 1s ease-in-out infinite alternate;
    }
  }

  &.percentage {
    // Not created yet
  }
`
